import { ColDef } from "ag-grid-community";
import { M1ShiftReportStackerBundle } from "../models/M1ShiftReportResponse";

const formatLength = (totalInches: number | null): string => {
	if (totalInches == null) return "";
	const abs = Math.abs(Math.round(totalInches));
	return `${Math.floor(abs / 12)}' ${abs % 12}"`;
};

export const useTableData = () => {
	const columnDefs: ColDef<M1ShiftReportStackerBundle>[] = [
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 80,
			flex: 1,
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "HeatName",
			headerName: "Heat",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "GradeName",
			headerName: "Grade",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "LengthInches",
			headerName: "Length",
			minWidth: 70,
			flex: 1,
			valueFormatter: (params) => formatLength(params.value),
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "GoodPieces",
			headerName: "Good Pieces",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) =>
				params.value != null ? params.value.toLocaleString() : "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "TotalWeight",
			headerName: "Total Weight",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) =>
				params.value != null ? params.value.toLocaleString() : "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "ScrapPieces",
			headerName: "Scrap Pieces",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) =>
				params.value != null ? params.value.toLocaleString() : "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "ScrapReason",
			headerName: "Reason for Scrap",
			minWidth: 120,
			flex: 1.5,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "flex-start" },
		},
	];

	return { columnDefs };
};
